import { render, staticRenderFns } from "./welcomPage.vue?vue&type=template&id=6f67ac7d&scoped=true"
import script from "./welcomPage.vue?vue&type=script&lang=js"
export * from "./welcomPage.vue?vue&type=script&lang=js"
import style0 from "./welcomPage.vue?vue&type=style&index=0&id=6f67ac7d&prod&lang=scss&scoped=true"
import style1 from "./welcomPage.vue?vue&type=style&index=1&id=6f67ac7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67ac7d",
  null
  
)

export default component.exports